module.exports = __webpack_public_path__ + "img/sante.74165230.jpg";